import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Modal from 'srcReact/components/common2/Modal'

const DeleteOrganizationPopin = ({ showDeleteOrganizationModal, setShowDeleteOrganizationModal }) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={showDeleteOrganizationModal} handleClose={setShowDeleteOrganizationModal}>
      <div className={styles.deleteOrganizationPopupWrapper}>
        <p
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: t('organizationSettings.modalDeleteText') }}
        />
      </div>
    </Modal>
  )
}

DeleteOrganizationPopin.propTypes = {
  showDeleteOrganizationModal: PropTypes.bool,
  setShowDeleteOrganizationModal: PropTypes.func
}

export default DeleteOrganizationPopin
